<template>
  <v-expansion-panel class="rounded-0 mb-2">
    <slot></slot>
  </v-expansion-panel>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ResumationExpansionPanel",
  data: () => ({}),
  props: {},
  components: {},
  methods: {},
  mounted() {},
  computed: {}
};
</script>
